export default __webpack_public_path__ + "static/media/client13.a10b8cab.jpeg";